<p-tabs [value]="0">
  <p-tablist>
    <p-tab [value]="0">{{ 'products.categorie' | translate }}</p-tab>
    <p-tab [value]="1">{{ 'products.attributes' | translate }}</p-tab>
  </p-tablist>

  <p-tabpanels>
    <p-tabpanel [value]="0">
      <div>
        <div class="flex align-items-center faded-products-count flex-column justify-content-center">
          <div class="w-full text-center pb-2">
            <div class="inline-flex align-items-center">
              <p-tag>{{ totalSelected }}</p-tag>
              <span class="ml-2">{{ "products.selectedProducts" | translate }}</span>
            </div>
          </div>
          <div class="w-full text-center">
            <div class="inline-flex align-items-center">
              <p-tag>{{ differentCategories }}</p-tag>
              <span class="ml-2" style="font-size: 13px;">{{ "products.differentCategories" | translate }}</span>
            </div>
          </div>
        </div>
        <div>
          @if (this.categories) {
            <p-treeSelect
              containerStyleClass="w-full"
              [showClear]="true"
              [options]="categories"
              placeholder="{{ 'global.selectItem' | translate }}">
              <ng-template #default let-node>
                <div><span>{{ node?.categoryLabelLoc }}</span></div>
              </ng-template>
              <ng-template #value let-node>
                <div>
                  @if (node?.categoryLabelLoc) {
                    <span>{{ node?.categoryLabelLoc }}</span>
                  } @else {
                    <span>{{ "global.selectItem" | translate }}</span>
                  }
                </div>
              </ng-template>
            </p-treeSelect>
          }
        </div>
      </div>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <!-- TODO modification en masse -->
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<div class="footer-buttons">
  <div class="flex">
    <div class="flex-1">
      <button
        pButton
        type="button"
        label="{{ 'buttons.cancel' | translate }}"
        [outlined]="true"
        icon="pi pi-times-circle"
        (click)="exitDialog()"></button>
    </div>
    @if (buttonOutlined) {
      <button
        pButton
        type="button"
        label="{{ 'buttons.validate' | translate }}"
        [outlined]="buttonOutlined"
        icon="pi pi-check-circle"
        (click)="closeDialog()"
        [disabled]="!buttonEnabled"></button>
    } @else {
      <button
        pButton
        type="button"
        label="{{ 'buttons.validate' | translate }}"
        icon="pi pi-check-circle"
        (click)="closeDialog()"
        [disabled]="!buttonEnabled"></button>
    }
  </div>
</div>
